import {useState, useEffect} from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { getPathName, ScrollToTop, setDefaultAll } from '../CodeEasier'
import { LazyHelmet } from '../../base'

import { app_name, static_img_url } from '../Variables'
import LazyImage from './LazyImage'

function NotNormalUser() {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()

  const [path, setPath] = useState('/')
  
function logOutAndCreate() {
  setDefaultAll(dispatch, true)
  navigate(`/user/createUser/?redirect=${path}`)
}

  useEffect(()=>{
     setPath(getPathName(location))
  },[location])
  
  return (
    <div className='handlers'>
    {/* <LazyHelmet>
      <title>Not Normal User ~ {app_name}</title>
    </LazyHelmet> */}

    
    <ScrollToTop/>
    <LazyImage src={`${static_img_url}/handlers/notnormaluser.webp`} alt={'Image'} />
    <div className='mt-3 mb-3'>It looks like you don't have a normal user account yet, Please sign up to access this page.</div>
    <button className='h7 primaryButton' onClick={() => logOutAndCreate()}>Create Account</button>
  </div>
  )
}

export default NotNormalUser